/**
 * Resolve the "source" of a lead — where the visitor came from.
 * Priority:
 *   1. Explicit source (e.g., section-specific override)
 *   2. UTM params (utm_source / utm_medium)
 *   3. Path-based fallback (/, /diwali, /joining-kit, /blog, /catalog)
 *
 * Returns a human-readable label like "Home Page", "Diwali Page",
 * "Google Ads", "Blog", "Catalog Download".
 */
export function getLeadSource(explicit) {
  if (typeof window === "undefined") return explicit || "Direct";

  const params = new URLSearchParams(window.location.search);
  const utmSource = (params.get("utm_source") || "").toLowerCase();
  const utmMedium = (params.get("utm_medium") || "").toLowerCase();
  const utmCampaign = params.get("utm_campaign");

  // Google Ads
  if (utmSource === "google" && (utmMedium === "cpc" || utmMedium === "paid" || utmMedium === "ppc")) {
    return utmCampaign ? `Google Ads · ${utmCampaign}` : "Google Ads";
  }
  // Meta / Facebook / Instagram Ads
  if ((utmSource === "facebook" || utmSource === "meta" || utmSource === "instagram") && (utmMedium === "cpc" || utmMedium === "paid")) {
    return utmCampaign ? `Meta Ads · ${utmCampaign}` : "Meta Ads";
  }
  // LinkedIn ads
  if (utmSource === "linkedin" && (utmMedium === "cpc" || utmMedium === "paid")) {
    return utmCampaign ? `LinkedIn Ads · ${utmCampaign}` : "LinkedIn Ads";
  }
  // Generic UTM
  if (utmSource) {
    return utmCampaign
      ? `${utmSource} · ${utmCampaign}`
      : `Campaign: ${utmSource}`;
  }

  // Explicit override (e.g., a Catalog Download page can pass "Catalog Download")
  if (explicit) return explicit;

  // Path-based fallback for future sub-pages
  const path = (window.location.pathname || "/").toLowerCase();
  if (path === "/" || path === "") return "Home Page";
  if (path.includes("diwali")) return "Diwali Page";
  if (path.includes("joining-kit") || path.includes("employee")) return "Employee Joining Kit Page";
  if (path.includes("blog")) return "Blog";
  if (path.includes("catalog")) return "Catalog Download";
  if (path.startsWith("/admin")) return "Admin";
  return `Page: ${path}`;
}
